module.exports = __webpack_public_path__ + "img/face-raised-eyebrow.31d99ab4.svg";